var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kadi4bkcia"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v1255H0V0h1440z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6jxkykd3yb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.114 23.788c1.16 0 2.1.94 2.1 2.1v.013A2.1 2.1 0 0 1 9.114 28H9.1A2.1 2.1 0 0 1 7 25.901v-.014a2.1 2.1 0 0 1 2.1-2.099h.014zm12.6 0c1.16 0 2.1.94 2.1 2.1v.013a2.1 2.1 0 0 1-2.1 2.099H21.7a2.1 2.1 0 0 1-2.1-2.099v-.014a2.1 2.1 0 0 1 2.1-2.099zM4.2 0a1.4 1.4 0 0 1 1.396 1.292l.224 2.906H26.6a1.4 1.4 0 0 1 1.391 1.554L26.85 16.029a4.199 4.199 0 0 1-3.875 3.724L8.477 20.788a4.2 4.2 0 0 1-4.486-3.866L3.127 5.705l-.223-2.906H1.4A1.4 1.4 0 1 1 1.4 0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kadi4bkcia)",
    transform: "translate(-92 -111)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6jxkykd3yb)",
    transform: "translate(92 111)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6B119",
    d: "M0 0h28v28H0V0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.a83cc342b37e9913775234bfbd7a2be9.svg";
export { ForwardRef as ReactComponent };